"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _icons = require("../../assets/icons");
var _Label = _interopRequireDefault(require("../Label"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["required", "helperText", "errorText", "disabled", "className", "labelClass", "inputClass", "description", "error", "value", "label", "name", "hideAlertIcon", "labelAlign", "invalidErrorMessage", "placeholder", "tooltip", "tooltipNotchPosition", "mobileTooltipNotchPosition", "valid", "id", "onFocus", "onChange", "onBlur", "setValue", "options", "noErrorsOrHelper"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".InputDropdown {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n.InputDropdown:focus-within .InputDropdown__select {\n  color: #424242;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15), 0px 2px 15px rgba(0, 0, 0, 0.08);\n  border-color: #0a5ec0;\n}\n.InputDropdown__select_wrapper {\n  position: relative;\n  display: block;\n}\n.InputDropdown__select_wrapper__disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.InputDropdown__select {\n  cursor: pointer;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid #bebebe;\n  border-radius: 0.188rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: #767676;\n  appearance: none;\n  outline: 0;\n  display: block;\n  background-color: #ffffff;\n}\n.InputDropdown__select__error {\n  border: 1px solid #c60f13;\n}\n.InputDropdown__select__error:focus {\n  border-color: #c60f13;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15), 0px 2px 15px rgba(0, 0, 0, 0.0750929);\n}\n.InputDropdown__select:hover[disabled=false] {\n  border: 1px solid #767676;\n}\n.InputDropdown__select.right_padding {\n  padding-right: 5rem;\n}\n.InputDropdown__icon {\n  position: absolute;\n  top: 50%;\n  transform: translate(-100%, -50%);\n  right: 1rem;\n  cursor: pointer;\n  transition: 0.2s ease-in-out all;\n  pointer-events: none;\n}\n.InputDropdown__error_or_description_text {\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  min-height: 1.25rem;\n  margin: 2px 0.25rem 0 0.25rem;\n  color: #767676;\n  font-weight: normal;\n}\n.InputDropdown__error_or_description_text__error {\n  font-weight: bold;\n  color: #c60f13;\n}";
  var fileName = "InputDropdown_InputDropdown";
  var element = document.querySelector("style[data-sass-component='InputDropdown_InputDropdown']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var InputDropdown = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? '' : _ref$helperText,
    _ref$errorText = _ref.errorText,
    errorText = _ref$errorText === void 0 ? '' : _ref$errorText,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? '' : _ref$labelClass,
    _ref$inputClass = _ref.inputClass,
    inputClass = _ref$inputClass === void 0 ? '' : _ref$inputClass,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    value = _ref.value,
    label = _ref.label,
    name = _ref.name,
    _ref$hideAlertIcon = _ref.hideAlertIcon,
    hideAlertIcon = _ref$hideAlertIcon === void 0 ? false : _ref$hideAlertIcon,
    _ref$labelAlign = _ref.labelAlign,
    labelAlign = _ref$labelAlign === void 0 ? 'left' : _ref$labelAlign,
    _ref$invalidErrorMess = _ref.invalidErrorMessage,
    invalidErrorMessage = _ref$invalidErrorMess === void 0 ? '' : _ref$invalidErrorMess,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Please Choose...' : _ref$placeholder,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    _ref$tooltipNotchPosi = _ref.tooltipNotchPosition,
    tooltipNotchPosition = _ref$tooltipNotchPosi === void 0 ? 'bottom-left' : _ref$tooltipNotchPosi,
    _ref$mobileTooltipNot = _ref.mobileTooltipNotchPosition,
    mobileTooltipNotchPosition = _ref$mobileTooltipNot === void 0 ? 'bottom-right' : _ref$mobileTooltipNot,
    _ref$valid = _ref.valid,
    valid = _ref$valid === void 0 ? [true, function () {}] : _ref$valid,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$onFocus = _ref.onFocus,
    _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onBlur = _ref.onBlur,
    _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$setValue = _ref.setValue,
    setValue = _ref$setValue === void 0 ? function () {} : _ref$setValue,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$noErrorsOrHelper = _ref.noErrorsOrHelper,
    noErrorsOrHelper = _ref$noErrorsOrHelper === void 0 ? false : _ref$noErrorsOrHelper,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (errorText !== '' && error === false) {
    console.error("Prop \"errorText\" requires an error prop to be passed to Input to display the errorText.");
  }
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    visited = _useState6[0],
    setVisited = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    requiredErr = _useState8[0],
    setRequiredErr = _useState8[1];
  var validate = function validate() {
    if (visited && !focused) {
      if (required) {
        if (value) {
          setRequiredErr(false);
          valid[1](true);
        } else {
          setRequiredErr(true);
          valid[1](false);
        }
      }
    } else {
      setRequiredErr(false);
      valid[1](true);
    }
  };
  var updateSelected = function updateSelected(list, val) {
    if (val > -1) {
      var selectedVal = list[val];
      setSelected(selectedVal);
    }
  };
  (0, _react.useEffect)(function () {
    if (!focused) {
      validate();
    }
  }, [focused]);
  (0, _react.useEffect)(function () {
    if (_onChange) {
      if (selected) {
        _onChange(selected);
      }
    }
  }, [selected]);
  var utilityPTag = function utilityPTag() {
    var pid = "".concat(id || label, "__input__helper");
    if (noErrorsOrHelper) {
      if (description) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "InputDropdown__error_or_description_text",
          "aria-live": "assertive",
          id: pid,
          children: description
        });
      }
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "InputDropdown__error_or_description_text ".concat(error || requiredErr ? 'InputDropdown__error_or_description_text__error' : ''),
      "aria-live": "assertive",
      id: pid,
      children: requiredErr ? invalidErrorMessage || "".concat(label, " is required.") : error ? errorText : description
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "InputDropdown ".concat(className),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Label["default"], {
      helperText: helperText,
      className: labelClass,
      tooltip: tooltip,
      error: requiredErr,
      tooltipAlign: tooltipNotchPosition,
      mobileTooltipAlign: mobileTooltipNotchPosition,
      required: required,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "InputDropdown__select_wrapper ".concat(disabled ? 'InputDropdown__select_wrapper__disabled' : ''),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("select", _objectSpread(_objectSpread({
        id: id,
        disabled: disabled,
        className: "InputDropdown__select ".concat(error || requiredErr ? 'InputDropdown__select__error' : '', " ").concat((error || requiredErr) && !hideAlertIcon ? 'right_padding' : ''),
        onFocus: function onFocus(e) {
          setVisited(true);
          setFocused(true);
          _onFocus(e);
        },
        onBlur: function onBlur(e) {
          setFocused(false);
          _onBlur(e);
          validate();
        },
        value: value,
        onChange: function onChange(e) {
          var val = e.target.value;
          setValue(val);
          _onChange(val);
          updateSelected(options, options.indexOf(val));
          validate();
        },
        ref: ref
      }, rest), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          className: "InputDropdown__select__option",
          value: "",
          children: placeholder
        }), options && options.map(function (val, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            className: "InputDropdown__select__option",
            value: val,
            children: val
          }, i);
        })]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconDownTriangle, {
        className: "InputDropdown__icon"
      })]
    }), utilityPTag()]
  });
});
InputDropdown.displayName = 'InputDropdown';
var _default = InputDropdown;
exports["default"] = _default;